import { getAuthToken, handleAuthTokenError, BASEURI } from '../utils';

// Cache for configurations
let configCache = {};

/**
 * Fetches sensitive configuration from the server
 * @param {string} configType - The type of configuration to fetch
 * @returns {Promise<Object>} - The configuration object
 */
export async function getSecureConfig(configType) {
  // Return from cache if available
  if (configCache[configType]) {
    return configCache[configType];
  }
  
  try {
    // Get auth token
    const token = await getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError);
    
    if (token === false) {
      throw new Error('Authentication failed');
    }
    
    // Fetch configuration from server
    const response = await fetch(`${BASEURI}/api/dashboard/secure-config/${configType}/`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": `Bearer ${token}`
      }
    });
    
    if (!response.ok) {
      throw new Error(`Failed to fetch ${configType} configuration`);
    }
    
    const config = await response.json();
    
    // Cache the configuration
    configCache[configType] = config;
    
    return config;
  } catch (error) {
    console.error(`Error fetching ${configType} configuration:`, error);
    throw error;
  }
}

/**
 * Clears the configuration cache
 */
export function clearConfigCache() {
  configCache = {};
} 